// Header row 1 status indicator. ✓ when clean, ⚠ when attention-needed.
// Click reveals a popover summarizing drift/failure counts in the current
// scope. V1 renders just the icon; the popover lands with the drift slice.

export function StatusIcon({ attentionCount = 0 }) {
  if (attentionCount > 0) {
    return (
      <button
        type="button"
        aria-label={`${attentionCount} item${attentionCount === 1 ? '' : 's'} need attention`}
        className="flex h-8 w-8 items-center justify-center rounded-md text-[var(--color-terracotta)] hover:bg-[var(--color-sandstone)]"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M8 1.5l7 12.5H1L8 1.5z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path d="M8 6v3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="8" cy="11.5" r="0.75" fill="currentColor" />
        </svg>
      </button>
    )
  }
  return (
    <output
      aria-label="No items need attention"
      className="flex h-8 w-8 items-center justify-center text-[var(--color-schist)]"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M3 8.5l3 3 7-7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </output>
  )
}
